import { Pipe, PipeTransform } from '@angular/core';
import { ChatMessageSegment } from './chat-mentions.types';

// Case-insensitive email validation pattern
const emailRegex =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/gi;

/** Splits a message into plain-text and email-mention segments. Returns data rather than an HTML
 * string so the template renders user-authored content as text, never as markup. */
@Pipe({
  name: 'chatMentions',
})
export class ChatMentionsPipe implements PipeTransform {
  transform(value: string | null | undefined, currentUserEmail?: string): ChatMessageSegment[] {
    if (!value) {
      return [];
    }

    const segments: ChatMessageSegment[] = [];
    let lastIndex = 0;

    for (const match of value.matchAll(emailRegex)) {
      const start = match.index ?? 0;
      if (start > lastIndex) {
        segments.push({ text: value.slice(lastIndex, start), isMention: false, isCurrentUser: false });
      }

      const email = match[0];
      const isCurrentUser = !!currentUserEmail && email.toLowerCase() === currentUserEmail.toLowerCase();
      segments.push({ text: email, isMention: true, isCurrentUser });
      lastIndex = start + email.length;
    }

    if (lastIndex < value.length) {
      segments.push({ text: value.slice(lastIndex), isMention: false, isCurrentUser: false });
    }

    return segments;
  }
}
